import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography
 } from '@material-ui/core';
import CloseableDialogTitle from 'components/layout/CloseableDialogTitle';

const LogModal = ({ classes, open, handleClose, content }) => {

  function handleCopy() {
    const joined = content.join('\n')
    const focusEl = document.activeElement
    const dummy = document.createElement('textarea');
    focusEl.appendChild(dummy); // When in dialog, MUI enforces focus on the dialog, preventing the dummy from selecting if appended to body. Append to element in dialog instead (potentially visible if it runs slow, can either look into hiding or just disableEnforceFocus for dialog)
    dummy.value = joined;
    dummy.select();
    document.execCommand('copy');
    focusEl.removeChild(dummy);
  }

  return (
    <Dialog onClose={handleClose} open={open} classes={{paper: classes.dialog}} scroll='paper'>
      <CloseableDialogTitle onClose={handleClose}>
        <Typography variant='h6'>Import Log</Typography>
      </CloseableDialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component='div'>
          {content?.length
            ? content.map((logItem, index) => {
                return (
                  <Typography key={index}>{logItem}</Typography>
                )
              })
            : <Typography>No log items found.</Typography>
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleClose}>Cancel</Button> */}
        <Button variant="contained" color="primary" onClick={handleCopy}>Copy to Clipboard</Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = theme => ({
  dialog: {
    maxWidth: 800
  }
});

export default withStyles(styles)(LogModal);